import "./widgetSm.css";
import { Visibility } from "@mui/icons-material";
import { useGetAllCustomersQuery } from '../../../services/userCRUDApi';
import { useNavigate } from 'react-router-dom';

export default function WidgetSm() {
  const { data, isSuccess, isLoading } = useGetAllCustomersQuery();
  const navigate = useNavigate();
  let arr = [];

  const handleDisplay = (props) => {
    navigate(`/admin/customer/edit/${props}`);
  };
  
  if (isLoading) return <div>Loading.....</div>;
  
  if (isSuccess) {
    arr = data.slice(-5);
  }

  return (
    <div className="widgetSm">
      <span className="widgetSmTitle">New Join Customers</span>
      <div className="widgetSmList">
        {arr.map((user, index) => (
          <div key={index} className="widgetSmListItem">
            <div className="widgetSmUserInfo">
              <span className="widgetSmUserId">{user.id}</span>
              <div className="widgetSmUserDetails">
                <span className="widgetSmUserName">
                  {user.first_Name} {user.last_Name}
                </span> 
                <span className="widgetSmUserPhone">{user.phone_Number}</span>
              </div>
            </div>
            <button 
              className="widgetSmButton" 
              onClick={() => handleDisplay(user.id)}
            >
              <Visibility className="widgetSmIcon" />
              Display
            </button>
          </div>
        ))}    
      </div>
    </div>
  );
}